import script from "./UserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=530a41ee&lang=scss"

const __exports__ = script;

export default __exports__